import React, { Component } from 'react';
import { IconButton } from '..';
import { connect } from 'react-redux';
import { 
  analyticsDispatcher, 
  cartDispatcher, 
  combineDispatchers, 
  configuratorDispatcher, 
  identityState, 
  messageDispatcher, 
  productsDispatcher,
  productState,
  siteSettingsState,
  currentNodeState,
  combineStates,
  superCodeDispatcher,
  repositoryState,
  filterDispatcher,
  filterSelectorState,
feasibilityDispatcher,
showConfigureDispatcher,
flagDispatcher,
flagState,
AppStore,
modelConfiguratorDispatcher,
modelConfiguratorState,
dialogDispatcher,
currentPageState
} from '../../store';
import { translate, service, flagActions } from '../../services';
import { WhiteCartIconNew, cartIcon, closePopup } from '../../../style/images';
import { PropTypes } from 'prop-types';
import { getUserAssignments, hasBomItemAssignment,getTransformedProducts , getConfiguration, translateProperty } from '../../util';
import URLSearchParams from '@ungap/url-search-params';
import { UserIdentity, prepareProducts,getAccessories } from '../../util';
import classNames from 'classnames';
import { Badge, Box, IconButton as MuiIconButton } from '@mui/material';
import { WindPowerSharp } from '@mui/icons-material';

export class AddToCartButtonComponent extends Component {
  constructor() {
    super();

    this.state = {
      isAdding: false,
      isDisabled: false,
      showMandatoryAccWarning:false,
    };
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

    //ga4
    trackProduct = (product) =>{
      const itemId = product.aBBID?product.aBBID:null;
      const itemName = product.description?product.description:null;
      const itemCategory = product.materialName?product.materialName:null;
      const itemQuantity = product.amount?product.amount:1;
      const itemPrice = product.price?product.price:0;
  
      const item = {
          item_id: itemId,
          item_name: itemName,
          item_category: itemCategory,
          item_price: itemPrice,
          item_quantity: itemQuantity
      }
  
      return item;
    }

  handleMessageResponse = message => {
    this.mounted && this.setState( { isAdding: false } );
    if ( message && message.dismissed ) {
      // nothing broke, but the user cancelled the process
      // so we used the reject to skip adding products to the cart
      if(message.mandatoryAccessoryMissing){
        // if mandatory accessories are there then reject and show warning dialog and stop adding product to cart.
        this.setState({isDisabled:true, showMandatoryAccWarning:true});
        this.props.showDialog(
          <div className='bom-item-missing'>
               <div className='content'>
               <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={this.props.closeDialog} style={{width:"24px", height:"24px"}} sx={{display:"flex",position:"absolute", top:"12px", right:"12px", background:"#F5F5F5", height:"20px", width:"20px", borderRadius:"56px" , backgroundColor: 'white'}}>
                  <Box component="img" src={closePopup} sx={{width:{md:'24px', xs:"18px"}, height: {md:'24px', xs:"18px"}}}></Box>
                </MuiIconButton>
                 <div className='header'>
                   <h5>{translate("Mandatory accessories required")}</h5>
                 </div>
                 <span>{translate( 
                        'Please select mandatory {tr:item}: {variables}', 
                        { item: message.missingMandatoryAccessory.length === 1 ? 'item' : 'items', variables: message.missingMandatoryAccessory.map( variable => translateProperty( variable.properties, variable.title ) ).join( ', ' ) } 
                      )}</span>
                 <Box sx={{width:"100%", display:"flex", justifyContent:"flex-end", height:"max-content", gap:"8px"}}>
                    <div className='secondary-button' onClick={()=>{
                        this.props.closeDialog();
                      }}>
                      <span>{translate("Go back")}</span>
                    </div>
                    {/* {(user.country.toLowerCase()==='de' || user.country.toLowerCase()==='decbol') && <div className='secondary-button' onClick={restrict ? ()=>{this.props.closeDialog()} : () => {resolve( products ); this.props.closeDialog()}}>
                      <span>{translate("Okay")}</span>
                    </div>} */}
                 </Box>
              </div>
             </div>,
             "mandatory-accessory-missing"
        )
      }
      return;
    }
    if ( message.reason ) {
      this.props.addMessage( { timeout: 15000, messageText: translate( message.reason ), messageType: 'warning' } );
      return;
    }
    this.props.notAdding()
    this.props.addMessage( { timeout: 15000, messageText: message && message.message ? message.message : message, messageType: 'error' } );
  };

  getAmount = ( product ) => (this.props.fromModelConfigurator ? 
    (this.props.modelConfigurator[product.code] || (product.isBomItemMain ? 1 : (isNaN(this.props.defaultAmount) ? 1: this.props.defaultAmount))) :
    (this.props.fixAmountFunc( product.amount || this.props.amount )));
  getNodeCID = () => {
    const {product, currentNode} = this.props;
    const nodeCID = product.properties && product.properties.any && product.properties.filter(p=>p?.name.indexOf('9AAC') > -1).firstOrDefault() != null ? product.properties.filter(p=>p?.name.indexOf('9AAC') > -1).map(n => n.name).firstOrDefault() : currentNode.nodeId;
    return nodeCID;
  }
  addMessage = ( messageText, messageType= 'confirmation', timeout= 0 ) => {
    return this.props.addMessage( {  timeout: timeout, messageText: translate( messageText ), messageType: messageType  } )
  }

  addToCbol = () => {
    const { product, user, products, assemblyType, isReadyAssembled, supercodeIdentified, currentNode, process, fromModelConfiguratorSelector, isEdit } = this.props;
    
    this.props.adding();
    this.mounted && this.setState( { isAdding: true } );
    var conf = getConfiguration( product, user );
    //conf object is a list to have both fixed and moving part configuration
    if( isReadyAssembled && conf[0].configuration.bom.length >= 1 ){
      return this.props.createSuperCode( getConfiguration( product, user ) )
      .then(
        superCodeResponse => {
          if( superCodeResponse.data[0].errors && superCodeResponse.data[0].errors.length ){
            this.addMessage( "Some error occured while creating supercode", "error", 0 );
          }
          else{
            let message = '';
              superCodeResponse.data.forEach(item => {
                if(item.response == '' && item.superCode){
                  message = message == '' ? message + `Successfully created ${item.superCode} in SAP`: message + '\n' + `Successfully created ${item.superCode} in SAP`;
                }else{
                  message = message == '' ? message + item.response: message + '\n' + item.response;
                }              
            })              
            this.addMessage( message);
            this.prepareProducts( Array.isArray( product ) ? product : [ { ...product, filterSelectors : product.filterSelectors || this.context.filterSelectors } ] ).then( async prods => {
              const tempTransformedProducts = getTransformedProducts(prods, products, user.authenticationType, 
                currentNode, this.context.properties, isReadyAssembled, assemblyType, superCodeResponse);
              let transformedProducts = [];
              tempTransformedProducts.forEach(item => {
                if( this.props.shoppingList && isReadyAssembled ){
                  transformedProducts.push({...item,properties: {...item.properties,shoppingList:null}});
                }
                else{
                  transformedProducts.push(item);
                }
                // transformedProducts.push(item);
                if( item.additionalProducts?.length ){
                  item.additionalProducts.forEach(prod => {
                    transformedProducts.push(prod);
                  })
                }
              });
              return service( 'formatdocument' ).post( transformedProducts, UserIdentity.token ).then( result => {
                document.cbolForm.action = user.properties.HookUrl;
                document.cbolForm.ConfigResponse.value = result.data;
                document.cbolForm.submit();   
                this.mounted && this.setState( { isAdding: false } );
                this.props.addMessage({
                    timeout: 5000,
                    messageText: translate("product sent to cart"),
                    messageType: "confirmation",
                  });
                  this.props.notAdding()
                transformedProducts.forEach( prod => {
                  const productList = !prod.children ? prod.title : prod.title.concat( ';', prod.children.map( acc => acc.title ) );
                  this.props.captureEvent( 'cart-items', 'cart-item-add', productList, ['commonTracker'] );
                    // ga4
                  dataLayer.push({ 
                    'event': "cart_item_add", 
                    event_action:'cart_item_add',
                    event_label : (prod.additionalProducts?.length>0?"FP+MP:":"").concat(productList),
                    event_fromWhere : (this.props.fromLooseAccessories?"LooseAccessories":this.props.mobileSearchView?"MobileSearch":this.props.currentPage.currentPage)+(this.props.fromSearchOverlay ? ":SearchOverlay" : ""),
                    event_instance:this.props.siteSettings.properties.GaInstance,
                    event_country: this.props.siteSettings.properties.GaCountry,
                    location_url:window.location.href
                  });

                });
              } );
            }).catch( this.handleMessageResponse ); 
          }
        }
      )
      .catch(
        () => this.addMessage( "Some error occured please try again", "error", 0 )
      )
    }
    else if( isReadyAssembled && conf.configuration.bom.length < 1 ){
      this.addMessage( "Please add accessory to configure", "warning", 0 )
    }
    else{
      return this.prepareProducts( Array.isArray( product ) ? product : [ { ...product, filterSelectors : product.filterSelectors || this.context.filterSelectors } ] ).then( prods => {
        const tempTransformedProducts = getTransformedProducts(prods, products, user.authenticationType, 
          currentNode, this.context.properties, isReadyAssembled, assemblyType, supercodeIdentified);
        let transformedProducts = [];
        tempTransformedProducts.forEach(item => {
          if( this.props.shoppingList ){
            transformedProducts.push({...item,properties: {...item.properties,shoppingList:null}});
          }
          else{
            transformedProducts.push(item);
          }
          // transformedProducts.push(item);
          if( item.additionalProducts?.length ){
            item.additionalProducts.forEach(prod => {
              transformedProducts.push(prod);
            })
          }
        });
        // AppStore.dispatch({type:flagActions.ADDING})
        this.props.adding()
        return service( 'formatdocument' ).post( transformedProducts, UserIdentity.token ).then( result => {
          // AppStore.dispatch({type:flagActions.NOTADDING})
           this.props.addMessage({
                      timeout: 5000,
                      messageText: translate("product sent to cart"),
                      messageType: "confirmation",
                    });
          this.props.notAdding()
          document.cbolForm.action = user.properties.HookUrl;
          document.cbolForm.ConfigResponse.value = result.data;
          document.cbolForm.submit();   
          this.mounted && this.setState( { isAdding: false } );
          transformedProducts.forEach( prod => {
            const productList = !prod.children ? prod.title : prod.title.concat( ';', prod.children.map( acc => acc.title ) );
            this.props.captureEvent( 'cart-items', 'cart-item-add', productList, ['commonTracker'] );
              // ga4
              
              dataLayer.push({ 
                'event': "cart_item_add", 
                event_action:'cart_item_add',
                event_label : (prod.additionalProducts?.length>0?"FP+MP:":"").concat(productList),
                event_fromWhere : (this.props.fromLooseAccessories?"LooseAccessories":this.props.mobileSearchView?"MobileSearch":this.props.currentPage.currentPage)+(this.props.fromSearchOverlay ? ":SearchOverlay" : ""),
                event_instance:this.props.siteSettings.properties.GaInstance,
                event_country: this.props.siteSettings.properties.GaCountry,
                location_url:window.location.href
              });

          })
        } );
      }).catch(this.handleMessageResponse ); 
    }
    // to hide the congifuration popup after product addedd to cart
    this.props.hideConfigure();
  }

  getWarningComponent( showWarning, product, warnPopup ) {
    if(this.state.showMandatoryAccWarning){
      return true;
    }
    if (showWarning && hasBomItemAssignment( product ) && !warnPopup  ) {
      // return <span key="warning" className="floating outward" title={translate('missing_bom_item')}>!</span>
      return true;
    }
    return false;
  }

  /**
   * @method prepareProducts
   * Allows all products to be updated before they are sent to the cart
   * in case a process function was added to the props, that method will be called and its result returned to any consumers, 
   * otherwise, the products will be returned
   * @param {Array<Product>} products 
   */
  async prepareProducts(products) {
    const { process,currentNode } = this.props;
    const HidePopup=currentNode?.customProperties?.HidePopup;
    if (!process) {
      return products;
    }
    products[0].HidePopup=HidePopup
    var bom = [];
    products.forEach(product => product.bomItems?.reduce((bom, item) => { bom.push(item.value.name?item.value.name: item.value); return bom; }, bom));
    products.forEach(product => product.fgProduct.forEach(( item) => bom.push(item.Name)));
    return this.props.getProducts(bom).then(() => process(products));
  }

  getSelector = (item) => {
    const { items: selectorsAll } = this.props;
    const selectorName = item.properties.firstOrDefault(property => property?.name.toLowerCase() === 'selectorname');
    if (!selectorName) {
      return null;
    }
    return selectorsAll.firstOrDefault(selector => selector.name.toLowerCase() === selectorName.value.toLowerCase());
  }

  async getFilterSelectorsValue(product) {
    if(product.filterSelectors && product.filterSelectors.length>0 ){
      return product
    }
    const {fromCart, isPopup, fromSearch} = this.props;
    const selector = this.getSelector(product);
    if(!selector) {
      return {...product, filterSelectors : product.filterSelectors || this.context.filterSelectors, nodeCID : this.getNodeCID() };
    }
    const {materialNameLso, assignments} = product;
    return this.props.getFilterSelectors(selector, this.props.user, false, false, false).then(filterSelectors => {
      const assignValue = (variableName, valueName) => {
        const filter = filterSelectors.firstOrDefault(filter => filter.identifier === variableName);
        const value = filter && filter.values.firstOrDefault(value => value.name === valueName);
        filter && filter.values.forEach(val => {
          if(val.isSelected == true){
          val.isSelected = false;
          }
        });
        if (value) {
          value.isSelected = true;
        }
      };

      //(!product.filterSelectors && isPopup) -- Opened configuration popup from search result
      if((!product.filterSelectors && isPopup) || fromSearch){
      filterSelectors.forEach(filter => {
        const val = filter.values.firstOrDefault(value => value.isSelected);
        if (val) {
          val.isSelected = false;
        }
      });
    }
	//Use the product.filterSelectors as payload for material API as it has user selections
	//This is applied only when user adding to cart from Configuration popup
    if(product.filterSelectors && isPopup){
      filterSelectors = product.filterSelectors;
    }

      if (selector.propertySource) {
        assignValue(selector.propertySource, materialNameLso);
      } else {
        for (let assignment of assignments) {
          assignValue(assignment.name, assignment.value);
        }
      }
      if (selector.sqlFilters && materialNameLso) {
        selector.sqlFilters = selector.sqlFilters.map(sqlFilter => !(/^materialnamelso$/i).test(sqlFilter.property) ? sqlFilter : { ...sqlFilter, equalsTo: materialNameLso });
      }

      return this.props.getFilterSelectorValue(filterSelectors, selector).then(filterSelector => {
        let filterSelectorValue = filterSelector || product.filterSelector || this.context.filterSelectors;
        return {...product, filterSelectors : filterSelectorValue, nodeCID : this.getNodeCID() };
      });
    });
  }

  addToCart( products ) {
    const { fromCart, oldProduct, product, isReadyAssembled, supercodeIdentified, user, isPopup, onClick, fromITCT, guid ,showWarning, fromModelConfigurator,deliveryOption,FG,fromSelect,fromConfigFooter,fromSearch} = this.props;
    if(!showWarning){
    this.mounted && this.setState( { isAdding: true } );
    }
    // this.props.adding();
    const { modelToLoad, properties } = this.context;
    let UpdatedProduct={...product}
    const quantityReset = this.props.currentNode.customProperties.DisableResetQuantity;
    const isVT=this.props.currentNode?.customProperties?.isVT;
    const acce = getAccessories(product);
    var index;
    if(isVT){
            product?.properties?.map((prop,idx)=>{if(prop.name=="Translation.EN"){index= idx}})
            if(index){delete product?.properties[index]};
          } 
    return this.prepareProducts( products).then( productsToAdd => {
      if ( fromCart ) {
        if( isReadyAssembled ){
          let tmpProduct = product;
          this.props.createSuperCode( getConfiguration( product, user ) )
          .then(
            superCodeResponse => {
              if( superCodeResponse.data[0].errors && superCodeResponse.data[0].errors.length ){
                this.addMessage( "Some error occured while creating supercode", "error", 0 );
              }
              else{
                let message = '';
                  superCodeResponse.data.forEach(item => {
                    if(item.response == '' && item.superCode){
                      message = message == '' ? message + `Successfully created ${item.superCode} in SAP`: message + '\n' + `Successfully created ${item.superCode} in SAP`;
                    }else{
                      message = message == '' ? message + item.response: message + '\n' + item.response;
                    }
                })
                this.addMessage( message );
                //set supercode for main part
                const mainProductSupercode = superCodeResponse.data.filter(d=>d.variantId == tmpProduct.name).firstOrDefault()?.superCode;
                if( mainProductSupercode ) tmpProduct.superCode = mainProductSupercode;
                //set supercode for fixed Part
                if( tmpProduct.additionalProducts.length > 0){
                  if( superCodeResponse.data.filter( d => d.variantId == tmpProduct.additionalProducts[0].code ).length ) {
                    const fixedPartSupercode = superCodeResponse.data.filter(d=>d.variantId == tmpProduct.additionalProducts[0].name).firstOrDefault()?.superCode;
                    tmpProduct.additionalProducts[0].superCode = fixedPartSupercode;
                  }
                }
                this.props.updateCart( { product: tmpProduct, oldProduct } );

                // to hide the congifuration popup after product addedd to cart
                !this.props.fromModelConfiguratorSelector && this.props.hideConfigure();
                
                const accessories = tmpProduct.configuration && getAccessories( tmpProduct ).
                  filter( a => !tmpProduct.assignments.any( i => i.value.indexOf(' ') === -1 && i.name === 'Variants.' + a.key ) );
                const productList = !accessories ? tmpProduct.name : tmpProduct.name.concat( ';', accessories.map( acc => acc.value ) );
                this.props.captureEvent( 'cart-items', 'cart-item-update', productList, ['commonTracker'] );
                  // ga4
                
                dataLayer.push({ 
                  'event': "cart_item_update", 
                  event_action:'cart_item_update',
                  event_label : (tmpProduct.additionalProducts.length>0 ? "FP+MP:":"").concat(productList),
                  event_instance:this.props.siteSettings.properties.GaInstance,
                  event_country: this.props.siteSettings.properties.GaCountry,
                  location_url:window.location.href
                  
                });

                // Capturing the productList part of the FP in GA in case of a FP+MP configuration
                if( tmpProduct.additionalProducts?.length ){
                  const tempAdditionalProduct = tmpProduct.additionalProducts[0];
                  const additionalAccessories = tempAdditionalProduct.configuration && getAccessories( tempAdditionalProduct ).
                  filter( a => !tmpProduct.assignments.any( i => i.value.indexOf(' ') === -1 && i.name === 'Variants.' + a.key ) );
                  const additionalProductsList = !additionalAccessories ? tempAdditionalProduct.name : tempAdditionalProduct.name.concat( ';', additionalAccessories.map( acc => acc.value ) );
                  this.props.captureEvent( 'cart-items', 'cart-item-update', additionalProductsList, ['commonTracker'] );
                  //ga4
                  dataLayer.push({ 
                    'event': "cart_item_update", 
                    event_action:'cart_item_update',
                    event_label : ("FP+MP:").concat(additionalProductsList),
                    event_instance:this.props.siteSettings.properties.GaInstance,
                    event_country: this.props.siteSettings.properties.GaCountry,
                    location_url:window.location.href
                   
                  });

                }
                onClick && isReadyAssembled && onClick();
                isPopup && !isReadyAssembled && setTimeout( () => this.props.removeConfiguration( product ), 0 );
              }
            }
          )
          .catch(
            () =>{
               // to hide the congifuration popup after supercode call fail
               !this.props.fromModelConfiguratorSelector && this.props.hideConfigure();
              this.addMessage(translate( "Some error occured while creating or adding configuration to the cart"), "error", 0 )}
          )
        }
        else{
        
          if(UpdatedProduct.additionalProducts && UpdatedProduct.additionalProducts[0]?.dummyCode){
            const looseadditionalProduct=UpdatedProduct.additionalProducts            
          
          UpdatedProduct={...UpdatedProduct,additionalProducts:[],looseadditionalProduct:looseadditionalProduct}};
          UpdatedProduct.superCode=supercodeIdentified?supercodeIdentified:UpdatedProduct.superCode;
          if(FG && FG.length>0){
            UpdatedProduct.superCodeLSO=FG
          }
          else if(UpdatedProduct.superCodeLSO && UpdatedProduct.superCodeLSO.length>0){
            UpdatedProduct.superCode=UpdatedProduct.superCodeLSOodeLSO;
          }
          UpdatedProduct.deliveryOption=deliveryOption?deliveryOption:'YES';
          var NST_description='';
          Object.keys(this.props.products).filter(p=>{if(this.props.products[p]?.code==(FG || UpdatedProduct.superCodeLSO )){NST_description= this.props.products[p]?.description}})
          UpdatedProduct.NST_description=NST_description;
          this.props.updateCart( { product:UpdatedProduct, oldProduct } );

          // to hide the congifuration popup after product addedd to cart
          !this.props.fromModelConfiguratorSelector && this.props.hideConfigure();
          const accessories = UpdatedProduct.configuration && getUserAssignments( UpdatedProduct.configuration ).
                    filter( a => !UpdatedProduct.assignments.any( i => i.value.indexOf(' ') === -1 && i.name === 'Variants.' + a.key ) );
          const productList = !accessories ? UpdatedProduct.name : UpdatedProduct.name.concat( ';', accessories.map( acc => acc.value ) );
          this.props.captureEvent( 'cart-items', 'cart-item-update', productList, ['commonTracker'] );
          dataLayer.push({ 
            'event': "cart_item_update", 
            event_action:'cart_item_update',
            event_label : productList,
            event_instance:this.props.siteSettings.properties.GaInstance,
            event_country: this.props.siteSettings.properties.GaCountry,
            location_url: window.location.href
           
          });
          // Capturing the productList part of the FP in GA in case of a FP+MP configuration
          if( product.additionalProducts?.length ){
            const tempAdditionalProduct = product.additionalProducts[0];
            const additionalAccessories = tempAdditionalProduct.configuration && getUserAssignments( tempAdditionalProduct.configuration ).
            filter( a => !product.assignments.any( i => i.value.indexOf(' ') === -1 && i.name === 'Variants.' + a.key ) );
            const additionalProductsList = !additionalAccessories ? tempAdditionalProduct.name : tempAdditionalProduct.name.concat( ';', additionalAccessories.map( acc => acc.value ) );
            this.props.captureEvent( 'cart-items', 'cart-item-update', additionalProductsList, ['commonTracker'] );
            dataLayer.push({ 
              'event': "cart_item_update",
              event_action:'cart_item_update',
              event_label :  additionalProductsList
            });
          }
        }
      } else {
        for ( let tmpProduct of productsToAdd ) {
          tmpProduct.modelToLoad = modelToLoad;
          tmpProduct.usCodeProps = properties;
          tmpProduct.superCode=supercodeIdentified?supercodeIdentified:tmpProduct.superCode;
          tmpProduct.isReadyAssembled=isReadyAssembled;
          if(FG && FG.length>0){
            tmpProduct.superCodeLSO=FG
          }
          else if(tmpProduct.superCodeLSO && tmpProduct.superCodeLSO.length>0){
            tmpProduct.superC=tmpProduct.superCodeLSOodeLSO;
          }
          if((fromSelect || fromSearch) && (tmpProduct.configurableProduct || tmpProduct?.properties?.any(p=>p.name=='Emax 2 Fixed Parts'))){
            
              tmpProduct.deliveryOption='YES';
            
            }
            else if(fromConfigFooter){
              tmpProduct.deliveryOption=deliveryOption?deliveryOption:'YES';
            }
            else{
              tmpProduct.deliveryOption="";
            }
          var NST_description='';
          Object.keys(this.props.products).filter(p=>{if(this.props.products[p]?.code==(FG || tmpProduct.superCodeLSO )){NST_description= this.props.products[p]?.description}})
          tmpProduct.NST_description=NST_description;
          if( isReadyAssembled ){
            this.props.createSuperCode( getConfiguration( product, user ) )
            .then(
              superCodeResponse => {
                if( superCodeResponse.data[0].errors && superCodeResponse.data[0].errors.length ){
                  this.addMessage( "Some error occured while creating supercode", "error", 0 );
                }
                else{
                  let message = '';
                  superCodeResponse.data.forEach(item => {
                    if(item.response == '' && item.superCode){
                      message = message == '' ? message + `Successfully created ${item.superCode} in SAP`: message + '\n' + `Successfully created ${item.superCode} in SAP`;
                    }else{
                      message = message == '' ? message + item.response: message + '\n' + item.response;
                    }
                  })
                  this.addMessage( message );
                  //set supercode for main part
                  const mainProductSupercode = superCodeResponse.data.filter( d => d.variantId == tmpProduct.name).firstOrDefault()?.superCode;
                  if( mainProductSupercode ) tmpProduct.superCode = mainProductSupercode;
                  //set supercode for fixed Part
                  if( tmpProduct.additionalProducts.length > 0 ){
                    if( superCodeResponse.data.filter( d => d.variantId == tmpProduct.additionalProducts[0].code ).length ){
                      const fixedPartSupercode = superCodeResponse.data.filter(d=>d.variantId == tmpProduct.additionalProducts[0].name).firstOrDefault()?.superCode;
                      tmpProduct.additionalProducts[0].superCode = fixedPartSupercode;
                    }
                  }
                  this.props.addToCart( { product: tmpProduct, amount: this.getAmount( tmpProduct ) } );

                  // to hide the congifuration popup after product addedd to cart
                  !this.props.fromModelConfiguratorSelector && this.props.hideConfigure();
                  
                  const accessories = tmpProduct.configuration && getAccessories( tmpProduct ).
                    filter( a => !tmpProduct.assignments.any( i => i.value.indexOf(' ') === -1 && i.name === 'Variants.' + a.key ) );
                  const productList = !accessories ? tmpProduct.name : tmpProduct.name.concat( ';', accessories );
                  this.props.captureEvent( 'cart-items', 'cart-item-add', productList, ['commonTracker'] );
                  //  ga4
                   dataLayer.push({ 
                    'event': "cart_item_add", 
                    event_action:'cart_item_add',
                    event_label : (tmpProduct.additionalProducts.length>0?"FP+MP:":"").concat(productList),
                    event_fromWhere : (this.props.fromLooseAccessories?"LooseAccessories":this.props.mobileSearchView?"MobileSearch":this.props.currentPage.currentPage)+(this.props.fromSearchOverlay ? ":SearchOverlay" : ""),
                    event_instance:this.props.siteSettings.properties.GaInstance,
                    event_country: this.props.siteSettings.properties.GaCountry,
                    location_url:window.location.href
                  });

                  // Capturing the productList part of the FP in GA in case of a FP+MP configuration
                  if( tmpProduct.additionalProducts?.length ){
                    const tempAdditionalProduct = tmpProduct.additionalProducts[0];
                    const additionalAccessories = tempAdditionalProduct.configuration && getUserAssignments( tempAdditionalProduct.configuration ).
                    filter( a => !tmpProduct.assignments.any( i => i.value.indexOf(' ') === -1 && i.name === 'Variants.' + a.key ) );
                    const additionalProductsList = !additionalAccessories ? tempAdditionalProduct.name : tempAdditionalProduct.name.concat( ';', additionalAccessories.map( acc => acc.value ) );
                    this.props.captureEvent( 'cart-items', 'cart-item-add', additionalProductsList, ['commonTracker'] );
                    //ga4
                     dataLayer.push({ 
                      'event': "cart_item_add",
                      event_action:'cart_item_add',
                      event_label : ("FP+MP:").concat(additionalProductsList),
                      event_fromWhere : (this.props.fromLooseAccessories?"LooseAccessories":this.props.mobileSearchView?"MobileSearch":this.props.currentPage.currentPage)+(this.props.fromSearchOverlay ? ":SearchOverlay" : ""),
                      event_instance:this.props.siteSettings.properties.GaInstance,
                      event_country: this.props.siteSettings.properties.GaCountry,
                      location_url:window.location.href
                    });
                  }
                  onClick && isReadyAssembled && onClick();
                  isPopup && !isReadyAssembled && setTimeout( () => this.props.removeConfiguration( product ), 0 );
                }
              }
            )
            .catch(
              () =>{ 

                 // to hide the congifuration popup after supercode call fail
                 !this.props.fromModelConfiguratorSelector && this.props.hideConfigure();

                this.addMessage(translate( "Some error occured while creating or adding configuration to the cart"), "error", 0 )}
            )
          }
          else if (fromITCT){
            this.props.getConfiguratorId(guid)
              .then(
                response => {
                  tmpProduct.name = response.data.data;
                  tmpProduct.code = response.data.data;
                  this.props.addToCart( { product: tmpProduct, amount: this.getAmount( tmpProduct ) } );
                  // to hide the congifuration popup after product addedd to cart
                  !this.props.fromModelConfiguratorSelector && this.props.hideConfigure();
                const accessories = tmpProduct.configuration && getUserAssignments( tmpProduct.configuration ).
                  filter( a => !tmpProduct.assignments.any( i => i.value.indexOf(' ') === -1 && i.name === 'Variants.' + a.key ) );
                const productList = !accessories ? tmpProduct.name : tmpProduct.name.concat( ';', accessories.map( acc => acc.value ) );
                this.props.captureEvent( 'cart-items', 'cart-item-add', productList, ['commonTracker'] );
                // ga4
              dataLayer.push({ 
              'event': "cart_item_add",
              event_action:'cart_item_add',
              event_label :  (tmpProduct.additionalProducts?.length>0?"FP+MP:":"").concat(productList),
              event_fromWhere : (this.props.fromLooseAccessories?"LooseAccessories":this.props.mobileSearchView?"MobileSearch":this.props.currentPage.currentPage)+(this.props.fromSearchOverlay ? ":SearchOverlay" : ""),
              event_instance:this.props.siteSettings.properties.GaInstance,
              event_country: this.props.siteSettings.properties.GaCountry,
              location_url:window.location.href
            });
                // Capturing the productList part of the FP in GA in case of a FP+MP configuration
                if( tmpProduct.additionalProducts?.length ){
                  const tempAdditionalProduct = tmpProduct.additionalProducts[0];
                  const additionalAccessories = tempAdditionalProduct.configuration && getAccessories( tempAdditionalProduct ).
                  filter( a => !tmpProduct.assignments.any( i => i.value.indexOf(' ') === -1 && i.name === 'Variants.' + a.key ) );
                  const additionalProductsList = !additionalAccessories ? tempAdditionalProduct.name : tempAdditionalProduct.name.concat( ';', additionalAccessories );
                  this.props.captureEvent( 'cart-items', 'cart-item-add', additionalProductsList, ['commonTracker'] );
                  //ga4
                   dataLayer.push({ 
                'event': "cart_item_add", 
                event_action:'cart_item_add',
                event_label :  ("FP+MP:").concat(additionalProductsList),
                event_fromWhere : (this.props.fromLooseAccessories?"LooseAccessories":this.props.mobileSearchView?"MobileSearch":this.props.currentPage.currentPage)+(this.props.fromSearchOverlay ? ":SearchOverlay" : ""),
                event_instance:this.props.siteSettings.properties.GaInstance,
                event_country: this.props.siteSettings.properties.GaCountry,
                location_url:window.location.href
              });
                }
                }
              )
          }
          else{
            if(tmpProduct.additionalProducts && tmpProduct.additionalProducts[0]?.dummyCode){
              const looseadditionalProduct=tmpProduct.additionalProducts
              tmpProduct={...tmpProduct,additionalProducts:[],looseadditionalProduct:looseadditionalProduct};
              
            }
            this.props.addToCart( { product: tmpProduct, amount: this.getAmount( tmpProduct ) } );

            // to hide the congifuration popup after product addedd to cart
            !this.props.fromModelConfiguratorSelector && this.props.hideConfigure();

            const accessories = tmpProduct.configuration && getUserAssignments( tmpProduct.configuration ).
              filter( a => !tmpProduct.assignments.any( i => i.value.indexOf(' ') === -1 && i.name === 'Variants.' + a.key ) );
            const productList = !accessories ? tmpProduct.name : tmpProduct.name.concat( ';', accessories.map( acc => acc.value ) );
            this.props.captureEvent( 'cart-items', 'cart-item-add', productList, ['commonTracker'] );
             //ga4
             dataLayer.push({ 
              'event': "cart_item_add", 
              event_action:'cart_item_add',
              event_label : (tmpProduct.additionalProducts?.length>0?"FP+MP:":"").concat(productList),
              event_fromWhere : (this.props.fromLooseAccessories?"LooseAccessories":this.props.mobileSearchView?"MobileSearch":this.props.currentPage.currentPage)+(this.props.fromSearchOverlay ? ":SearchOverlay" : ""),
              event_instance:this.props.siteSettings.properties.GaInstance,
              event_country: this.props.siteSettings.properties.GaCountry,
              location_url:window.location.href
            });
            // Capturing the productList part of the FP in GA in case of a FP+MP configuration
            if( tmpProduct.additionalProducts?.length ){
              const tempAdditionalProduct = tmpProduct.additionalProducts[0];
              const additionalAccessories = tempAdditionalProduct.configuration && getUserAssignments( tempAdditionalProduct.configuration ).
              filter( a => !tmpProduct.assignments.any( i => i.value.indexOf(' ') === -1 && i.name === 'Variants.' + a.key ) );
              const additionalProductsList = !additionalAccessories ? tempAdditionalProduct.name : tempAdditionalProduct.name.concat( ';', additionalAccessories.map( acc => acc.value ) );
              this.props.captureEvent( 'cart-items', 'cart-item-add', additionalProductsList, ['commonTracker'] );
              //ga4
               dataLayer.push({ 
                'event': "cart_item_add", 
                event_action:'cart_item_add',
                event_label : ("FP+MP:").concat(additionalProductsList),
                event_fromWhere : (this.props.fromLooseAccessories?"LooseAccessories":this.props.mobileSearchView?"MobileSearch":this.props.currentPage.currentPage)+(this.props.fromSearchOverlay ? ":SearchOverlay" : ""),
                event_instance:this.props.siteSettings.properties.GaInstance,
                event_country: this.props.siteSettings.properties.GaCountry,
                location_url:window.location.href
              });
            }
          }
        }
      }
      this.mounted && this.setState( { isAdding: false } );
      quantityReset ? this.props.fromModelConfigurator && !fromCart :
        this.props.fromModelConfigurator && !fromCart && this.props.resetQuantityList();
    } ).catch( this.handleMessageResponse );
  }

  addToLocalCart() {
    const { isPopup, onClick, product, isReadyAssembled, user, currentNode,fromModelConfigurator,fromModelConfiguratorSelector } = this.props;
    const isVT=currentNode?.customProperties?.isVT;
    var index;
    if(isVT){
            product?.properties?.map((prop,idx)=>{if(prop.name=="Translation.EN"){index= idx}})
            if(index){delete product?.properties[index]};
          } 
      
    let productsList = Array.isArray( product ) ? 
    (fromModelConfigurator && product.filter(p => this.getAmount(p) > 0)) || product 
    : [ { ...product, filterSelectors : product.filterSelectors || this.context.filterSelectors, nodeCID : this.getNodeCID() } ];
    const bomItemMain = fromModelConfigurator && productsList.find(p => p.isBomItemMain);
    let productsToAdd = [];
    if(bomItemMain) {
      bomItemMain["configuration"]["bomComponents"] = productsList.filter(p => !p.isBomItemMain).map(p => ({component: p.code, quantity: this.getAmount(p), description: p.description, netPrice: p.netPrice}));
      const nodeCID = bomItemMain.properties.filter(p=>p.name.indexOf('9AAC') > -1).firstOrDefault() != null ? bomItemMain.properties.filter(p=>p.name.indexOf('9AAC') > -1).map(n => n.name).firstOrDefault() : currentNode.nodeId;
      productsList = [{...bomItemMain, filterSelectors : product.filterSelectors || this.context.filterSelectors, nodeCID : nodeCID } ];
      this.addToCart( productsList );
          onClick && !isReadyAssembled && onClick();
          isPopup && !isReadyAssembled && setTimeout( () => this.props.removeConfiguration( product ), 0 );
          
          // to hide the congifuration popup after product addedd to cart
          // this.props.hideConfigure();

          // this.props.notAdding()

          if( ( user.authenticationType === 'WS' || user.authenticationType === 'PartnerHub' ) && window.location.hash.split('/')[1] === 'configure' ) {
            window.location.href = '#/cart';
            this.setState( { validated: true } );
          }
    } else {
    productsList?.map(p => {
      this.getFilterSelectorsValue(p).then(itemToAdd => {
        productsToAdd.push(itemToAdd);
        if(productsToAdd.length === productsList.length) {
          this.addToCart( productsToAdd );
          onClick && !isReadyAssembled && onClick();
          isPopup && !isReadyAssembled && setTimeout( () => this.props.removeConfiguration( product ), 0 );

          // this.props.notAdding()

          if(!this.props.fromModelConfiguratorSelector && ( user.authenticationType === 'WS' || user.authenticationType === 'PartnerHub' ) && window.location.hash.split('/')[1] === 'configure' ) {
            window.location.href = '#/cart';
            this.setState( { validated: true } );
          }
        }
      })
    })
  }
   
  }

  onAdd = () => {

    // this.mounted && this.props.adding()
    ( this.props.user.useLocalCart && this.props.user.authenticationType !== 'Cbol' ) || 
    ( this.props.fromCart && this.props.user.authenticationType === 'Cbol' ) ? 
    this.addToLocalCart() : this.addToCbol()
    this.props.onClose && this.props.onClose()
    // this.props.notAdding();
  }

  calculateTotalAmount = product => {
    const bomItemMain = product.find(p => p.isBomItemMain);
    if(!bomItemMain) return false;
    return Array.isArray( product ) ? ((bomItemMain && this.getAmount(bomItemMain)) ||
    product?.reduce((acc, p) => acc + this.getAmount(p), 0)) : this.getAmount(product);
  }

  render() {
    let { disabled, fromCart, hidden, text, user, showWarning, product, isPopup, tooltip, className, shoppingList, warnPopup, isEdit,visibility } = this.props;
    const { isAdding } = this.state;
    const { properties } = this.context;
    const hideAddToCart = properties && properties.canAddToCart !== undefined && !properties.canAddToCart;
    const classname = classNames("round-button", "icon-bg-black")

    if ( !user || user.useLocalCart && !user.hasCart ) {
      return null;
    }

    if ( !isPopup && hideAddToCart ) {
      return null;
    }

    if(product && product.hideAddButton){
      return null;
    }

    // if(this.props.fromConfigurator && !this.props.fromModelConfiguratorSelector && !this.props.hasAccessories){
    //   disabled = true;
    // }
    return<>
    {visibility!=undefined && !visibility?<></>:
    this.props.fromQuantityDialog?<>
        <IconButton
        key="icon-button"
        tooltip={ tooltip ||  translate( shoppingList ? 'Add to shopping list' : fromCart ? 'Update product in cart' : 'Add to cart' ) }
        //className={ className || (shoppingList ? "add-to-shopping-cart" : "add-to-cart-button") }
        // className = "round-button"
        className = {className='primary-button'}
        // icon={  !this.props.fromConfigurator&&WhiteCartIconNew }
        onClick={this.onAdd}
        text={translate(shoppingList ? 'Add to shopping list' : fromCart ? 'Update product in cart' : 'Add to cart') }
        disabled={ disabled}
        hidden={ hidden }
        getWarningComponent = {this.getWarningComponent( showWarning, product, warnPopup )}
        />
    </>:
    [<IconButton
      key="icon-button"
      tooltip={ tooltip ||  translate( shoppingList ? 'Add to shopping list' : fromCart || isEdit ? 'Update product in cart' : 'Add to cart' ) }
      //className={ className || (shoppingList ? "add-to-shopping-cart" : "add-to-cart-button") }
      // className = "round-button"
      className = {!this.props.fromConfigurator&&!this.props.fromModelConfiguratorFooter&&!shoppingList?classname:"primary-button"}
      icon={  !this.props.fromConfigurator&&!this.props.fromModelConfiguratorFooter&&!shoppingList&&WhiteCartIconNew }
      onClick={()=>{this.onAdd() }}
      text={translate(this.props.fromConfigurator||this.props.fromModelConfiguratorFooter || shoppingList ?text || shoppingList ? 'Shopping List' : fromCart || isEdit ? isEdit? "Update" : 'Update product in cart' : 'Add to cart':"") }
      disabled={ this.state.isDisabled || disabled || (this.props.fromModelConfigurator && !this.calculateTotalAmount(product)) }
      hidden={ hidden }
      getWarningComponent = {this.getWarningComponent( showWarning, product, warnPopup )}
      showMandatoryWarning={this.props.siteSettings.properties.showMandatoryWarning}
      />]}
    </>
  }
}

AddToCartButtonComponent.propTypes = {
  addMessage: PropTypes.func.isRequired,
  addToCart: PropTypes.func.isRequired,
  amount: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  fromCart: PropTypes.bool,
  getProducts: PropTypes.func.isRequired,
  hidden: PropTypes.bool,
  isPopup: PropTypes.bool,
  oldProduct: PropTypes.shape( {} ),
  onClick: PropTypes.func,
  product: PropTypes.oneOfType(
    [
      PropTypes.arrayOf( PropTypes.shape( {} ) ),
      PropTypes.shape( {
        amount: PropTypes.number
      } )
    ]
  ),
  removeConfiguration: PropTypes.func.isRequired,
  text: PropTypes.string,
  updateCart: PropTypes.func.isRequired,
  user: PropTypes.shape( {
    hasCart: PropTypes.bool,
    useLocalCart: PropTypes.bool
  } ),
  captureEvent: PropTypes.func.isRequired,
  showWarning: PropTypes.bool,
  process: PropTypes.func,
  currentNode: PropTypes.shape( {
    customProperties: PropTypes.shape( { 
      modelToLoad: PropTypes.string,
      canAddToCart: PropTypes.bool,
      enableReadyAssembledInCbol: PropTypes.array
    } ),
    selectorName: PropTypes.string
  } ),
};

AddToCartButtonComponent.contextTypes = {
  modelToLoad: PropTypes.string,
  properties: PropTypes.shape( {
    canAddToCart: PropTypes.bool,
    enableReadyAssembledInCbol: PropTypes.array
    } ),
  filterSelectors: PropTypes.array
};

export const AddToCartButton = connect( 
  combineStates( identityState,siteSettingsState,modelConfiguratorState, productState, currentNodeState, repositoryState('selector'),filterSelectorState, flagState, currentPageState ), 
  combineDispatchers( analyticsDispatcher,flagDispatcher, filterDispatcher, cartDispatcher, configuratorDispatcher, messageDispatcher, productsDispatcher, superCodeDispatcher, feasibilityDispatcher, showConfigureDispatcher,modelConfiguratorDispatcher, dialogDispatcher  ) 
)( AddToCartButtonComponent );
